import React, { useContext } from 'react';
import PropTypes from 'prop-types';
import { useToast } from '@redshelf/redshelf-ui';

import { ConfirmationDialog } from 'components';
import { OfflineModifiersContext, OfflineValuesContext } from 'contexts';

/* Cancel ongoing download */
const CancelDownloadConfirm = ({
  cancelDownloadDialogProps,
  setCancelDownloadDialogProps,
  ...props
}) => {
  const { closeToast } = useToast();

  const { cancel } = useContext(OfflineModifiersContext);
  const { wholeBookDownloading } = useContext(OfflineValuesContext);

  return (
    <ConfirmationDialog
      title="Are you sure you want to proceed?"
      titleComponent="h5"
      message="Your download is not complete. By proceeding, this content will not be available for offline use."
      cancel={{
        label: 'Never Mind',
        action: () => {
          setCancelDownloadDialogProps({ isOpen: false, marker: null });
        },
      }}
      confirm={{
        label: 'Proceed',
        action: async () => {
          if (wholeBookDownloading) {
            await cancel();
            closeToast('completeBook');
          } else if (cancelDownloadDialogProps?.marker) {
            await cancel(cancelDownloadDialogProps?.marker);
            cancelDownloadDialogProps.markersDownloadingRef.current?.delete(
              cancelDownloadDialogProps?.marker,
            );
          } else {
            await cancel();
          }

          setCancelDownloadDialogProps({ isOpen: false, marker: null });
        },
      }}
      id={'confirmCancelDownloadDialog'}
      isOpen={cancelDownloadDialogProps.isOpen}
      labelledById="cancel-download-confirmation"
      {...props}
    />
  );
};

CancelDownloadConfirm.propTypes = {
  cancelDownloadDialogProps: PropTypes.object,
  setCancelDownloadDialogProps: PropTypes.func,
};

export default CancelDownloadConfirm;
